var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "joy-share-config" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "config-form",
          attrs: { model: _vm.form, "label-width": "140px" },
        },
        [
          _c("div", { staticClass: "section-title" }, [_vm._v("基础参数")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "点餐-商家前缀",
                        prop: "merchantPrefix",
                        rules: [
                          {
                            required: true,
                            message: "商家前缀不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.merchantPrefix,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "merchantPrefix", $$v)
                          },
                          expression: "form.merchantPrefix",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "点餐-appKey",
                        prop: "appKey",
                        rules: [
                          {
                            required: true,
                            message: "appKey不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.appKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appKey", $$v)
                          },
                          expression: "form.appKey",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "点餐-appSecret",
                        prop: "appSecret",
                        rules: [
                          {
                            required: true,
                            message: "appSecret不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.appSecret,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appSecret", $$v)
                          },
                          expression: "form.appSecret",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "点餐-供应商",
                        prop: "supplier",
                        rules: [
                          {
                            required: true,
                            message: "供应商不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.supplier,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supplier", $$v)
                          },
                          expression: "form.supplier",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "点餐-回调地址" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.callbackUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "callbackUrl", $$v)
                          },
                          expression: "form.callbackUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "热门城市" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.hotCities,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "hotCities", $$v)
                          },
                          expression: "form.hotCities",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section-title" }, [_vm._v("超时指标")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "超时时间（分钟）",
                        prop: "timeoutMinutes",
                        rules: [
                          {
                            required: true,
                            message: "超时时间不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "number" },
                        model: {
                          value: _vm.form.timeoutMinutes,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "timeoutMinutes", _vm._n($$v))
                          },
                          expression: "form.timeoutMinutes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "出餐超时提醒方式",
                        prop: "timeoutNotifyMethod",
                        rules: [
                          {
                            required: true,
                            message: "出餐超时提醒方式不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.timeoutNotifyMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "timeoutNotifyMethod", $$v)
                            },
                            expression: "form.timeoutNotifyMethod",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "群机器人", value: "robot" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "飞书", value: "feishu" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "邮件", value: "email" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "手机", value: "phone" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "接收人" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "群名、飞书Id、邮箱号、手机号" },
                        model: {
                          value: _vm.form.receivers,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receivers", $$v)
                          },
                          expression: "form.receivers",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "消息模板" } },
                    [
                      _c("el-input", {
                        staticClass: "message-textarea",
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          placeholder:
                            "您有一笔订单【{订单号}】出餐已超时{超时时间}分钟，请尽快处理，避免影响用户体验。",
                        },
                        model: {
                          value: _vm.form.messageTemplate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "messageTemplate", $$v)
                          },
                          expression: "form.messageTemplate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "medium" }, on: { click: _vm.resetForm } },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }